'use strict';

export default Number.isFinite || function isFinite(value) {
    return (typeof value === 'number' && !Number.isNaN(value) && value !== Infinity && value !== -Infinity);
}